// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"a1e782cc","656":"7c26e00a","756":"d642b095","831":"735b3702","968":"83a40fd9"}[chunkId] + ".chunk.js";
};